import { render, staticRenderFns } from "./KGrid.vue?vue&type=template&id=4c24d80a&"
import script from "./KGrid.vue?vue&type=script&lang=js&"
export * from "./KGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports